import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Navbar from '../../../Components/Navbar'
import Container from 'react-bootstrap/Container'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../wallet.css'
import InsideMenu from '../../../Components/InsideMenu'
import moment from 'moment'
import { Icon, Button, Modal } from 'antd'
// import LoginWallet from '../loginWallet'
import { login } from '../../../redux-flow/actions/wallet'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import SideBar from '../../../Components/SideBar'
import flwt_possuo from '../../../images/wallet/flwt_possuo.png'
import flwt_nao from '../../../images/wallet/flwt_nao.png'
import flwt_oque from '../../../images/wallet/flwt_oque.png'
import { setInfoLocalStorage, getInfoLocalStorage } from '../../../utils/api'
import BoxToken from '../../../Components/BoxToken'

const stateFromLocalStorage = getInfoLocalStorage()

const menu = [
    {   
        icone: flwt_possuo,
        titulo: "Já possuo FLWT",
        subtitulo: "Conecte sua Phantom Wallet para acessar seu dashboard",
        botao: "Conectar Phantom Wallet",
        key: 1,
    },
    {   
        icone: flwt_nao,
        titulo: "Não possuo FLWT",
        subtitulo: "Crie e conecte sua Phantom Wallet e compre seus FLWTs agora!",
        botao: "Comprar FLWT",
        link: 'https://phantom.app/',
        key: 2,
        modalLabel: "Como criar sua Phantom Wallet"
    },
    {   
        icone: flwt_oque,
        titulo: "O que é FLWT?",
        subtitulo: "Entenda como participar e receber as recompensas!",
        botao: "Página do FLWT",
        link: '#',
        key: 3,
        modalLabel: "Leia o Whitepaper"
    },
]

class FlwtWallet extends PureComponent {
    constructor(props) {
    super(props)
    this.state = {
        password: '',
        loading: false,
        conversoes: this.props.statement,
        filter: 0,
        currentPage: 1, 
        req: false,
        modalToken: false,
        error: false, 
        loaded: false
    }}
    
    componentDidMount() {
        const { onLoad, userid } = this.props
        if(onLoad && userid) {
            onLoad(userid)
        }
        // const isPhantomInstalled = window.solana && window.solana.isPhantom
        // if(isPhantomInstalled && !window.solana.isConnected) {
        //     this.connectWallet()
        // }
    }

    componentDidUpdate(prevState, prevProps) {
        const { walletLogged } = this.props
        if(walletLogged){
            this.setState({
                req: true
            })
            const key = stateFromLocalStorage.key
            const error = new URLSearchParams(window.location.search).get('error')
            if(key && key !== null && !error) {
                window.location.replace("/wallet/flwt/painel")
            } else {
                if(error && !this.state.loaded) {
                    this.setState({error: true, loaded: true})
                }
            }
        }
    }

    handleCloseModal = () => {
        console.log('teste')
        new URLSearchParams(window.location.search).delete('error')
    }

    handleButton = (e) => {
        console.log(e)
        if(e === 1) {
            this.connectWallet()
        } else if(e === 2) {
            this.handleModal()
        } else {
            window.location.replace("/produtos/flwt")
        }
    }

    connectWallet = async () => {
        const isPhantomInstalled = window.solana && window.solana.isPhantom
        if(isPhantomInstalled) {
            try {
                const resp = await window.solana.connect();
                const key = resp.publicKey.toString()
                const phantom = { key }
                setInfoLocalStorage(phantom)
                window.location.replace("/wallet/flwt/painel")
                // 26qv4GCcx98RihuK3c4T6ozB3J7L6VwCuFVc7Ta2A3Uo 
            } catch (err) {
                console.log(err)
                // { code: 4001, message: 'User rejected the request.' }
            }
        } else {
            window.open("https://phantom.app/", "_blank");
        }
    }
    
    handleModal = () => {
        const aux = this.state.modalToken
        this.setState({ modalToken: !aux })
    }
        
    render() {

            const { logged, userLogged, userExpiration, loginExpired, walletLogged } = this.props
            return (
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> : (
                        userLogged.permissao === 0 || userLogged.permissao === 2 || userLogged.permissao === 4 ? <Redirect to="/minhaconta" /> :
                        <div>
                            <Container>
                                    <div className="section minhaContaWrapper">
                                        <Row>
                                            <Col md={12} className="p-0">
                                                <InsideMenu /> 
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="section insideSec">
                                        <Row>
                                            <Col md={2} className="p-0" style={{borderRight: '1px solid #F6F3FF'}}>
                                                <SideBar permissao={userLogged.permissao} nivelVerificacao={userLogged.nivelVerificacao} />
                                            </Col>
                                            <Col md={10}>                                  
                                            <div>
                                                <Row className="section">
                                                    <Col md={1}/>
                                                    <Col md={11}>
                                                        <Row>
                                                            {menu.map (item => (
                                                                <Col className="mt-3 mb-2" md={4}>
                                                                    <div className='boxFlwt'>
                                                                        <img className='imgFlwt' src={item.icone}/>
                                                                        <h2 className="tituloFlwt">{item.titulo}</h2>
                                                                        <p className="subTituloFlwt">{item.subtitulo}</p>
                                                                        <Button onClick={() => this.handleButton(item.key)} className="btnGrafico mt-3" name="saque">
                                                                            {item.botao}
                                                                        </Button>
                                                                        
                                                                        {
                                                                            item.modalLabel ?
                                                                                <div className="infoFlwtWrapper">
                                                                                    <a href={item.link} target="_blank" className="infoFlwt">{item.modalLabel} </a>
                                                                                    {/* <img className='modalInfoIcon' src={modalInfoIcon}/> */}
                                                                                </div>
                                                                            : <div className="infoFlwtWrapper"/>
                                                                        }

                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                                <BoxToken modalToken={this.state.modalToken} handleModal={this.handleModal} />
                                <Modal 
                                    visible={this.state.error}
                                    footer={false}
                                    maskClosable={false}
                                    onCancel={() => this.setState({error: false})}
                                    onClick={() => this.setState({error: false})}
                                    
                                >
                                    <h2>Ops!</h2>
                                    <p>Parece que você tentou se conectar de carteira com um endereço diferente do qual você recebeu seus tokens. Por favor, conecte-se com a carteira correta ou entre em contato com nossa equipe.</p>
                                </Modal>
                        </div>
                        
                    )}
                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
    userid: state.login.userid,
    userExpiration: state.wallet.userExpiration,
    loginExpired: state.wallet.loginExpired,
    walletLogged: state.wallet.walletLogged
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    },
    handleSubmit: (pass, email, userid) => {
        dispatch(login(pass, email, userid))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(FlwtWallet)